module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maryann Reid\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Maryann Reid obtained her masters of fine arts degree from the University of Miami, has written for "), _c('I', [_vm._v("Glamour")]), _vm._v(" magazine, and her novella, "), _c('I', [_vm._v("Single Black Female")]), _vm._v(", appeared on USAToday.com. "), _c('I', [_vm._v("Mrs. Big")]), _vm._v(" is her fourth book. She lives in Brooklyn, New York.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nZWIsR/tc-custom/9781466859203.jpg?1732164946034",
      "alt": "This image is the cover for the book Mrs. Big"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mrs. Big\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Loletta Hightower likes to live "), _c('i', [_vm._v("big")]), _vm._v(": exotic vacations, designer clothing, trips to the spa.  But it gets harder and harder to support her lavish lifestyle working the reception desk at a luxury car dealership. And though Loletta can con athletes, celebrities, and wealthy businessmen into taking care of her bills for a few months at a time, she wants the holy grail of every gold-digging businesswoman: the ring."), _c('br'), _vm._v("When she runs into Kavon \"Big\" Jackson, an NBA player and former college classmate of hers, she finds it really isn't so hard to snag a high-profile husband. But it sure is hard to keep him satisfied. \"Big\" lives up to his name in every way, including his temper and his libido---neither of which Loletta can control. As violence and infidelity escalate in their home, so does Loletta's resolve. She's got a few surprises up her own sleeve, and the drama is just beginning.…")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0